<template>
    <div class="row mb-md-60px mb-40px mx-0 mx-md-1 double-column-cta-layout carousel-product">
        <div class="col-12">
            <h2 class="agp-normal mb-20px" v-html="title_carousel"></h2>
            <div
            :data-type="postType"
            :class="[
                'master-section glide-slider mb-0px mb-md-0px carousel-slider-master',
                {
                'grid-layout': options_type === 'gridlayout',
                ['carousel-slider-' + postType]: options_type === 'carousel'
                }
            ]">
                <GridLayoutBlog v-if="options_type == 'gridlayout' && postType == 'blog'" :data="data_blog"></GridLayoutBlog>
                <template v-if="options_type == 'gridlayout' && postType == 'product'" v-for="( item, item_id) in data_product" :key="item_id">
                    <ListingItem :item = item ></ListingItem>
                </template >
                <template v-if="options_type == 'carousel' && postType == 'product'">
                    <CarouselProduction
                    v-if="data_product" :loop="false"
                    :dataListing="data_product"
                    :modules="modules"  :slidesPerView="5"
                    :slidesPerGroup ="1"
                    :breakpoints="swiperBreakpoints"
                    :parentId="'master_crousel_' + index_crousel" />
                </template>

                <template v-if="options_type == 'carousel' && postType == 'blog'">
                    <CarouselBlog
                        v-if="data_blog" :loop="false"
                        :data="data_blog"
                        :modules="modulesBlog"  :slidesPerView="2"
                        :slidesPerGroup ="2"
                        :breakpoints="swiperBreakpointsBlog">
                    </CarouselBlog>
                </template>
            </div>
        </div>
    </div>

</template>
<script lang="ts" setup>
    import { ref } from "vue";
    import GridLayoutBlog from "./Carousel/GridLayoutBlog.vue";
    import ListingItem from "~/components/Product/ProductItem.vue";
    import CarouselProduction from "~/components/Product/CarouselProduction.vue";
    import CarouselBlog from "./Carousel/CarouselBlog.vue";
    import { Navigation, Pagination } from "swiper/modules";
    const modules = [Navigation];
    const modulesBlog = [Pagination];

    const props = defineProps(["data", "data_item", "data_index"]);
    const data_carousel = computed(() => props.data);
    const data_product_item = computed(() => props.data_item);
    const index_crousel = computed(() => props.data_index);
    const title_carousel = ref('');
    const postType = ref('');
    const data_product = ref();
    const options_type = ref('');
    const data_blog = ref('');
    const key_title_product = ref('');


    const swiperBreakpoints = {
        320: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 2,
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    };
    const swiperBreakpointsBlog = {
        320: {
            slidesPerView: 1,
            slidesPerGroup: 1
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    };



    title_carousel.value = data_carousel.value[0]?.title;
    postType.value = data_carousel.value[0]?.select_postytype;
    options_type.value = data_carousel.value[0]?.format_session;
    data_blog.value = data_carousel.value[0]?.select_post;
    key_title_product.value = data_carousel.value[0]?.product_section_id;
    // data_product.value = data_product_item.value[key_title_product.value].filter(
    //     (product) => product.status !== "outofstock"
    // );
    watch(
        () => [data_product_item.value, key_title_product.value],
        ([newDataProductItem, newKeyTitleProduct]) => {
            if (newDataProductItem && newKeyTitleProduct) {
            const filteredProducts = newDataProductItem[newKeyTitleProduct]?.filter(
                (product) => product.status !== "outofstock"
            );
            data_product.value = filteredProducts || [];
            } else {
                data_product.value = [];
            }
        },
        { immediate: true }
    );

</script>
<style lang="scss">
    @import '@/assets/scss/components/master-template/_master-gridlayout.scss';

</style>